module.exports = __webpack_public_path__ + "static/media/noRulesSmiley.ac61b80c.svg";